module.exports = __webpack_public_path__ + "img/advantage2.6d4d2e09.svg";